import React from 'react';
import { Link } from 'react-router-dom';
import { FiShield, FiTwitter, FiFacebook, FiLinkedin, FiMail, FiExternalLink } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-primary-dark text-white pt-20 pb-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20">
          {/* Brand Column */}
          <div className="lg:col-span-5 space-y-6">
            <div className="flex items-center gap-3">
              <div className="bg-primary-light p-2 rounded">
                <FiShield size={24} className="text-white" />
              </div>
              <span className="text-2xl font-serif font-black tracking-tight">MORINGA ALERT</span>
            </div>
            <p className="text-gray-400 text-lg leading-relaxed max-w-md">
              The premier journalistic authority on botanical supplement safety. Providing independent verification, recall tracking, and investigative reporting for the global health community.
            </p>
            <div className="flex gap-5">
              <a href="#" className="w-10 h-10 rounded-full border border-gray-700 flex items-center justify-center hover:bg-primary-light hover:border-primary-light transition-all"><FiTwitter size={18} /></a>
              <a href="#" className="w-10 h-10 rounded-full border border-gray-700 flex items-center justify-center hover:bg-primary-light hover:border-primary-light transition-all"><FiFacebook size={18} /></a>
              <a href="#" className="w-10 h-10 rounded-full border border-gray-700 flex items-center justify-center hover:bg-primary-light hover:border-primary-light transition-all"><FiLinkedin size={18} /></a>
            </div>
          </div>

          {/* Links Grid */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-10">
            <div>
              <h3 className="text-xs font-black uppercase tracking-[0.3em] text-primary-light mb-6">Journal</h3>
              <ul className="space-y-4 text-sm font-medium text-gray-400">
                <li><Link to="/news" className="hover:text-white transition-colors">Latest Investigations</Link></li>
                <li><Link to="/alerts" className="hover:text-white transition-colors">Recall Archive</Link></li>
                <li><Link to="/products" className="hover:text-white transition-colors">Product Database</Link></li>
                <li><Link to="/resources" className="hover:text-white transition-colors">Safety Standards</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-xs font-black uppercase tracking-[0.3em] text-primary-light mb-6">Verification</h3>
              <ul className="space-y-4 text-sm font-medium text-gray-400">
                <li><a href="https://www.fda.gov" className="hover:text-white flex items-center gap-2">FDA Portal <FiExternalLink size={12}/></a></li>
                <li><a href="https://www.cdc.gov" className="hover:text-white flex items-center gap-2">CDC Reports <FiExternalLink size={12}/></a></li>
                <li><a href="#" className="hover:text-white">Lab Partners</a></li>
                <li><a href="#" className="hover:text-white">Methodology</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-xs font-black uppercase tracking-[0.3em] text-primary-light mb-6">Support</h3>
              <ul className="space-y-4 text-sm font-medium text-gray-400">
                <li><Link to="/about" className="hover:text-white">Our Mission</Link></li>
                <li><Link to="/contact" className="hover:text-white">Contact Desk</Link></li>
                <li><Link to="/disclaimer" className="hover:text-white">Legal Notice</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-10 flex flex-col md:flex-row justify-between items-center text-[10px] font-bold uppercase tracking-[0.2em] text-gray-500">
          <p>&copy; {new Date().getFullYear()} MORINGA ALERT • WWW.MORINGAALERT.COM</p>
          <div className="flex gap-8 mt-6 md:mt-0">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/disclaimer" className="hover:text-white">Editorial Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;